import { useState } from "react";
import Select from "react-select";
import constants from "../utils/constants";
import style from "../utils/style";

const AccountTypesDropdown = ({ label, placeholder, value, onChange }) => {
	let options = [
		{ label: "Bank", value: "bank" },
		{ label: "Capital", value: "capital" },
		{ label: "CurrentAsset", value: "currentAsset" },
		{ label: "Customer", value: "customer" },
		{ label: "Expense", value: "expense" },
		{ label: "Employee", value: "employee" },
		{ label: "FixAsset", value: "fixAsset" },
		{ label: "Income", value: "income" },
		{ label: "Product", value: "product" },
		{ label: "Supplier", value: "supplier" },
	];
	// capital, currentAsset, bank, income, expense, customer, supplier, fixAsset, product, employee
	const [selectedValue, setSelectedValue] = useState({
		label: label,
		value: value,
	});

	const styles = {
		control: (base, state) => ({
			...base,
			minHeight: 56,
			height: 56,
			border: state.isFocused
				? `2px solid ${constants.PRIMARY}`
				: "`2px solid grey`",
			boxShadow: "none",
			...style.marginY2,
		}),
		valueContainer: (base) => base,
		option: (base, { isSelected }) => ({
			...base,
			backgroundColor: isSelected ? constants.PRIMARY : "none",
		}),
		input: (base) => base,
		placeholder: (base) => base,
		singleValue: (base) => base,
		menuPortal: (base) => base,
		menu: (base) => ({ ...base, zIndex: 9 }),
	};

	return (
		<div className="input-control">
			<Select
				closeMenuOnSelect={true}
				options={options}
				placeholder={placeholder || label}
				label={label}
				components={{
					IndicatorSeparator: () => null,
				}}
				defaultValue={selectedValue}
				value={options.find((option) => option.value === value) || ""}
				onChange={(v) => {
					setSelectedValue(v);
					onChange(v.value);
				}}
				styles={styles}
			/>
		</div>
	);
};

export default AccountTypesDropdown;
